export default __webpack_public_path__ + "static/willofwork-efaaad94dfef6bfd172002d4895bea98.png";